import $ from 'jquery';
import { accountPromote } from "../queries";
import Popup from "../utilities/Popup";

$('.js-page-personal-promote').click(async function () {
    await accountPromote();
    setInterval(() => {window.location.reload()}, 5000);
    // ;
});

